import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const STATUS = ["Pendiente", "En progreso", "Completado"];
const STATUS_COLOR = {
  "Pendiente": "bg-stone-100 text-stone-700",
  "En progreso": "bg-amber-50 text-amber-800",
  "Completado": "bg-emerald-50 text-emerald-800",
};

export default function StaffCommittees() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/committees").then(r => setList(r.data)).finally(() => setLoading(false));
  }, []);

  const changeStatus = async (c, status) => {
    const prev = list;
    setList(list.map(x => x.id === c.id ? { ...x, status } : x));
    try {
      await api.patch(`/committees/${c.id}`, { status });
      toast.success(`${c.name} → ${status}`);
    } catch {
      setList(prev);
      toast.error("No fue posible actualizar");
    }
  };

  return (
    <div data-testid="staff-committees" className="space-y-6">
      <div>
        <div className="overline text-[var(--brand-primary)]">Comités</div>
        <h2 className="font-serif-cg text-3xl md:text-4xl tracking-tight mt-2">Equipos del evento</h2>
      </div>

      {loading ? (
        <p className="text-[var(--brand-muted)]">Cargando comités...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {list.map((c, idx) => (
            <article key={c.id} data-testid={`committee-${idx}`} className="card-cg p-6 flex flex-col">
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-serif-cg text-xl tracking-tight">{c.name}</h3>
                <span className={`text-[11px] px-2 py-1 ${STATUS_COLOR[c.status] || ""}`}>{c.status}</span>
              </div>
              <div className="overline text-[var(--brand-muted)] mt-4">Líder</div>
              <div className="text-sm">{c.leader}</div>

              <div className="overline text-[var(--brand-muted)] mt-3">Integrantes</div>
              <div className="text-sm text-[var(--brand-ink)]/80">{c.members.join(" · ")}</div>

              <div className="overline text-[var(--brand-muted)] mt-3">Tareas principales</div>
              <p className="text-sm text-[var(--brand-ink)]/80 leading-relaxed">{c.tasks}</p>

              <div className="hairline my-4" />
              <div className="flex flex-wrap gap-2 mt-auto">
                {STATUS.map(s => (
                  <button
                    key={s}
                    data-testid={`committee-${idx}-status-${s}`}
                    onClick={() => changeStatus(c, s)}
                    className={`text-[11px] px-2.5 py-1 border ${
                      c.status === s
                        ? "bg-[var(--brand-primary)] text-white border-[var(--brand-primary)]"
                        : "border-[var(--brand-border)] hover:border-[var(--brand-primary)]"
                    }`}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
